import { useEffect } from "react";

function useDisableBrowserBack () 
{
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);

    const popStateListner = () => {
      window.history.pushState(null, "", window.location.href);
      alert('browser back button has disabled for medieval me!');
      return false;
    };
    
    window.addEventListener('popstate',popStateListner);

    return () => { 
      window.removeEventListener('popstate', popStateListner);
    };
    
  }, []);
};

export default useDisableBrowserBack;